import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Dialog,
  DialogContent,
  makeStyles,
  Divider,
  Typography,
  Select,
  FormControl,
  TextareaAutosize
} from "@material-ui/core";
import { getMotivosInsucesso } from "../../../../state/order/actions";
import { DialogActions } from "../components/DialogActions";
import { useCommonStyles } from "../useCommonStyles";
import { dialogTokenLocale } from "./dialog-token-locale";
import DialogTokenContent from "./DialogTokenContent";

const useStyles = makeStyles((theme) => ({
  sectionTitle: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
  },
  sectionTitleText: {
    fontSize: 16,
  },
  reasonTitle: {
    textAlign: 'center',
    color: '#1A1A1A',
  },
  reasonSelect: {
    borderRadius: 8,
    border: '1px solid #808080',
  }
}));


export default function DialogToken({ open, handleClose, tokenProp, orderId, mode = 'retirada', abbiamoStatus, handleSubmit: handleSubmitFromProps }) {

  const classes = { ...useCommonStyles(), ...useStyles() };

  const [motivoInsucessoId, setMotivoInsucessoId] = useState(null);
  const [motivoDevolucao, setMotivoDevolucao] = useState(null);

  const dispatch = useDispatch();
  const { motivosInsucesso } = useSelector((state) => state.orders);

  useEffect(() => {
    if (open) dispatch(getMotivosInsucesso());
  }, [open, dispatch]);

  const handleSubmitDevolucao = ({ nomeAutorizador, emailAutorizador } = {}) => {
    const motivoSelect = motivosInsucesso.find(
      (m) => m.motivo === motivoInsucessoId
    );
    if (motivoSelect)
      handleSubmitFromProps(motivoSelect, motivoDevolucao, nomeAutorizador, emailAutorizador);
  };

  const handleSubmit = mode === 'devolucao' ? handleSubmitDevolucao : handleSubmitFromProps;

  return (
    <Dialog open={open} onClose={handleClose} classes={{ paper: classes.dialog }}>
      <Divider className={classes.divider} />

      {mode === 'devolucao' && (
        <DialogContent className={classes.content}>
          <Typography className={classes.reasonTitle}>Selecione o motivo da <strong>devolução.</strong></Typography>
          <FormControl variant="outlined" fullWidth className={classes.form}>
            <Select
              className={classes.reasonSelect}
              native
              value={motivoInsucessoId}
              onChange={(e) => setMotivoInsucessoId(e.target.value)}
              inputProps={{
                name: "motivoInsucessoId",
                id: "motivoInsucessoId",
              }}
            >
              <option key={`0-motivo`} value={""}>
                Selecione uma opção
              </option>
              {motivosInsucesso.map((item, index) => (
                <option key={`${index}-motivo`} value={item.motivo}>
                  {item.nome}
                </option>
              ))}
            </Select>
          </FormControl>
          <TextareaAutosize
            fullWidth
            variant="outlined"
            placeholder="Descrição da devolução"
            name="motivoDevolucao"
            id="motivoDevolucao"
            margin="dense"
            rowsMin={4}
            value={motivoDevolucao}
            style={{ flex: 1, padding: 10, borderRadius: 8, borderColor: '#808080', minHeight: '112px' }}
            onChange={(e) => {
              setMotivoDevolucao(e.target.value);
            }}
          />
        </DialogContent>
      )}

      <DialogContent className={classes.content}>
        <DialogTokenContent mode={mode} orderId={orderId} isAbbiamoStatusNotDone={abbiamoStatus !== 'DONE'} />
      </DialogContent>
      <Box className={classes.bottomContent}>
        <Divider className={classes.dividerBottom} />
        <DialogActions
          handleClose={handleClose}
          handleSubmit={handleSubmit}
          disabled={(mode === 'retirada' && abbiamoStatus !== 'DONE') || (mode === 'devolucao' && (!motivoInsucessoId || !motivoDevolucao))}
          buttonText={dialogTokenLocale[mode].buttonText}
        />
      </Box>
    </Dialog>
  );
}
